import { Skeleton } from '@mui/material'
import React from 'react'

import { USkeletonProps } from './type'

export const USkeleton = ({ variant = 'text', ...props }: USkeletonProps) => {
  return <Skeleton variant={variant} sx={{ fontSize: '1rem' }} {...props} />
}
